



















import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator';
import cookies from 'js-cookie';
import $ from 'jquery';
import { SHOPBY_ACCESSTOKEN, SHOPBY_REFRESHTOKEN } from '@/const/words/cookie';
import { sendTokenPostMessage } from './util';
import { logSend } from '@/utils/logUtils';
import { namespace } from 'vuex-class';
import {Admin} from '@/types/admin';
const adminModule = namespace('admin');

@Component({})
export default class AdminIframe extends Vue {
  @adminModule.Getter('admin') private admin!: Admin;

  @Prop({ required: false, default: '' })
  private iframeStyle: string;

  @Prop({ required: true, default: '' })
  private src: string;

  @Prop({ required: false, default: false })
  private isPopup: boolean;

  @Prop({ required: false, default: false })
  private isNcua: boolean;

  @Prop() private readonly onLoadIframe!: () => void;

  @Ref()
  public readonly iFrame: HTMLIFrameElement;

  @Watch('src')
  private updateSrc() {
    $('#iframe-loading').show();

    this.iFrame.setAttribute('url', this.src);

    this.sendMessageIFrame();
  }

  private receiveMessage(e: MessageEvent) {
    if (e.data === 'loaded') {
      this.sendMessageIFrame();
      $('#iframe-loading').hide();

      this.onLoadIframe?.();

      return;
    }

    if (e.data.type === 'refreshToken') {
      e.data.SHOPBY_ACCESSTOKEN && cookies.set(SHOPBY_ACCESSTOKEN, e.data.SHOPBY_ACCESSTOKEN.value, { expires: e.data.SHOPBY_ACCESSTOKEN.expires })
      e.data.SHOPBY_REFRESHTOKEN && cookies.set(SHOPBY_REFRESHTOKEN, e.data.SHOPBY_REFRESHTOKEN.value, { expires: e.data.SHOPBY_REFRESHTOKEN.expires })

      return;
    }

    if (e.data.type === 'frame-size' && e.data.height) {
      this.iFrame.style.height = `${e.data.height}px`;
    }

    if (e.data.url || e.data.queryParam) {
      if (e.data.from !== 'remote') {
        // NOTE: 부정사용 의심자의 어드민 정보를 logncrash로 보낸다
        const { mallNos, no } = this.admin ?? {};
        logSend(
          JSON.stringify({
            type: 'suspicious-behavior',
            mallNos,
            no,
            data: e.data,
          })
        );
      }

      const queryString = new URLSearchParams(e.data.queryParam).toString();

      const url = `${e.data.url ?? ''}${queryString ? '?'+ queryString : ''}`;

      if (e.data.replace === true) {
        this.$router
          .push(url)
          .catch((err) => {
            if (err?.name !== 'NavigationDuplicated') {
              throw err;
            }
          });
      } else {
        this.$router
          .replace(url)
          .catch((err) => {
            if (err?.name !== 'NavigationDuplicated') {
              throw err;
            }
          });
      }
    }

    if (e.data.close) {
      window.close();
    }
  }

  private sendMessageIFrame() {
    this.iFrame && sendTokenPostMessage(this.iFrame);
  }

  mounted() {
    this.iFrame.onload = () => {
      $('#iframe-loading').hide();
    };

    window.addEventListener('message', this.receiveMessage);
  }

  beforeUnmount() {
    window.removeEventListener('message', this.receiveMessage);
  }
}
